import styled from '@emotion/styled';
import { iconTertiary, iconTertiaryHover } from '../../utils/inconsistentVars';

const btnIconsStyles = `
  background: ${iconTertiary};
  color: var(--podium-cds-color-text-primary);

  &:focus-visible {
    box-shadow: inset 0 0 0 2px var(--podium-cds-color-border-focus);
    outline: none;
  }
`;

/**
 * Icon container for Nike AI header icon
 * Matches UserTools icon button styling for consistent hover behavior
 */
export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: var(--podium-cds-button-border-radius);
  ${btnIconsStyles}

  &:hover,
  &:active {
    background: ${iconTertiaryHover};
  }
`;
